import useHttpPost from "./useHttpPost";

function usePostDiaryEntry(transaction) {
  return useHttpPost("diaryentries", "post", {}, transaction);
}

export default usePostDiaryEntry;
